module.exports = __webpack_public_path__ + "media/images/new/icons/mall-b060aee5f9767f840ed9eee5cbdad2f5.png";